module.exports = __webpack_public_path__ + "src/assets/img/hxjs_jsjg_02@2x.073792c7.png";